var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex m-auto"},[_c('div',{staticClass:"flex-grow divider"}),(_vm.title)?_c('div',{staticClass:"flex-grow-0 px-5 title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"flex-grow divider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }